'use client'

import Image from 'next/image'

import { Text } from '@/shared/components/typography'
import type { LegacyRef, ReactNode } from 'react'

const PurchaseHeader = ({
  text,
  onClick,
  headerRef,
  backIcon,
  onClickClose
}: {
  text: string
  onClick: () => void
  onClickClose: () => void
  headerRef: LegacyRef<HTMLDivElement> | null
  backIcon: ReactNode
}) => {
  return (
    <div ref={headerRef} className="sticky top-0 flex h-[56px] w-full items-center justify-between bg-010 px-4 py-4">
      <div className="flex gap-2">
        <div className="cursor-pointer" onClick={onClick}>
          {backIcon}
        </div>
        <Text level="text3" color="text090">
          {text}
        </Text>
      </div>
      <div onClick={onClickClose}>
        <Image
          src={'/icons/light_icn_close_24.svg'}
          width={18}
          height={18}
          alt={'닫기아이콘'}
          className="h-6 w-6 cursor-pointer"
        />
      </div>
    </div>
  )
}

export default PurchaseHeader
